// extracted by mini-css-extract-plugin
module.exports = {"banners":"Slide_banners__6wyba"};